import { Link } from '@mui/material';

export const DataLink = ({ link, text }) => {
  return (
    <Link href={link} target='_blank'>
      {text}
    </Link>
  );
};
